import F2Utils from './f2'

export default {
  F2Utils,
}
